const ClientRoutes = [
    {
      path: "/clients",
      name: "Clients",
      component: () => import("@/pages/clients/ClientListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Client'
        }
      },
      children: [
        {
          path: "new_client",
          name: "NewClient",
          component: () => import("@/pages/clients/NewClientPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Client'
            }
          },
        },
        {
          path: ":id",
          name: "ShowClient",
          component: () => import("@/pages/clients/ShowClientPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'read', on: 'Client'
            }
          },
        }
      ]
    },
  ]
  
  export default ClientRoutes